import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

const points = [
  "Crystal-Clear focus असेल, जे तुम्हाला तुमचं खरं potential ओळखायला मदत करेल.",
  "Unshakable confidence मिळून तुम्ही तुमच्या dream life च्या जवळ जाल.",
  "Powerful mindset shifts ज्यामुळे तुम्ही unstoppable बनाल.",
  "Visible progress using scientifically-proven manifestation techniques."
];

const FutureSelf = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div style={{
      backgroundColor: '#f7eded',
      padding: '50px 20px',
      textAlign: 'center',
      fontFamily: 'Outfit, sans-serif'
    }}>
      <h2 style={{
        fontSize: isMobile ? '22px' : '28px',
        fontWeight: '900',
        marginBottom: '40px',
        color: '#333'
      }}>
        Imagine करा 2 Days नंतर तुमचं Future Self
      </h2>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'center',
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        {points.map((text, idx) => (
          <div key={idx} style={{
            backgroundColor: '#e8fff2',
            border: '1px solid #c8f0d4',
            borderRadius: '12px',
            padding: isMobile ? '10px 15px' : '10px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            flex: '1 1 400px',
            minHeight: '80px'
          }}>
            <FaCheckCircle color="#000" size={20} style={{ flexShrink: 0 }} />
            <span style={{
              textAlign: 'left',
              fontSize: isMobile ? '14px' : '16px',
              fontWeight: 500,
              lineHeight: '1.4'
            }}>
              {text}
            </span>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button style={{
          background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
          color: 'white',
          fontSize: isMobile ? '18px' : '20px',
          padding: isMobile ? '10px 40px' : '25px 80px',
          border: 'none',
          borderRadius: '20px',
          fontWeight: 'bold',
          cursor: 'pointer',
          width: isMobile ? '100%' : 'auto',
        }}>
          Join The 2 Day Workshop for ₹199&nbsp;
         <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
        </button>
        <p style={{
          marginTop: '10px',
          color: '#000',
          fontSize: '16px',
          fontFamily: 'Outfit,sans-serif',
          fontStyle: 'italic'
        }}>
         <span style={{fontWeight:'600'}}> Registrations End on </span><span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
         <span style={{fontWeight:'600'}}> 100%</span> मनी बॅक गॅरंटी | समाधानी नसल्यास
        </p>
      </div>
    </div>
  );
};

export default FutureSelf;
